import { useCallback, useMemo } from 'react';
import { useService } from '../common';
import type { ServiceResponse } from '../common/types';
import { AccountTransactionRecord, TransactionDetailRecord } from './types';

const API = {
    ACCOUNT_TRANSACTION: '/account/transaction',
    REWARDABLE_TRANSACTION: '/rewardable/transaction?transactionId=<transactionId>',
};

export const useTransactionService = () => {
    const service = useService();
    const getTransactions = useCallback((): ServiceResponse<AccountTransactionRecord[]> => {
        return service.sendGetWithAuthorization(API.ACCOUNT_TRANSACTION)
            .then(service.handleResponse)
            .catch(error => Promise.resolve(error));
    }, [service]);

    const getRewardableTransaction = useCallback((transactionId: string): ServiceResponse<TransactionDetailRecord> => {
        const url = API.REWARDABLE_TRANSACTION.replace('<transactionId>', transactionId);
        return service.sendGetWithAuthorization(url)
            .then(service.handleResponse)
            .catch(error => Promise.resolve(error));
    }, [service]);

    return useMemo(() => ({
        getTransactions,
        getRewardableTransaction,
    }), [
        getTransactions,
        getRewardableTransaction,
    ]);
};
